/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ReleaseStatusFromJSON, ReleaseStatusToJSON, ResourceTagFromJSON, ResourceTagToJSON, } from './';
export function ContentReleaseRequestFromJSON(json) {
    return ContentReleaseRequestFromJSONTyped(json, false);
}
export function ContentReleaseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ResourceTagFromJSON)),
        'releaseStatus': ReleaseStatusFromJSON(json['releaseStatus']),
        'releaseMessage': !exists(json, 'releaseMessage') ? undefined : json['releaseMessage']
    };
}
export function ContentReleaseRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(ResourceTagToJSON)),
        'releaseStatus': ReleaseStatusToJSON(value.releaseStatus),
        'releaseMessage': value.releaseMessage
    };
}
